import React, { useEffect, useState } from 'react'
import { Popup } from 'antd-mobile'
import { CloseOutlined } from '@ant-design/icons'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import './css/GrowthRecord.css'

export default function Preview(props) {

  const [visible, setVisible] = useState(false)
  const [list, setList] = useState([])

  const getData = () => {
    Dialog.loading()
    general.axios.post('/honorRewardPreview', {
      type: props?.type,
    }).finally(() => {
      Dialog.close()
    }).then(res => {
      setList(res.data.data)
      setVisible(props.visible)
    })
  }

  useEffect(() => {
    setVisible(props.visible)
    if (props.visible) {
      getData()
    }
  }, [props.visible])

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
        }}
      >
        <div className='preview-index'>
          <div className="close" onClick={() => props.handleDismiss()}>
            <CloseOutlined></CloseOutlined>
          </div>
          {list.length > 0 && <div className="header">
            <div className="title">{props.type === 1 ? '荣耀日奖励预览' : props.type == 2 ? '生日特权奖励预览' : '周五福利奖励预览'}</div>
          </div>}
          <div className="container">
            <table>              <tbody>
              {list.map((item, index) => (
                <tr key={index}>
                  <td>{item.k}</td>
                  <td>
                    {item.v.split('\n').map((coupon, index) => (
                      <div key={index}>{coupon}</div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
            </table>
          </div>
        </div>
      </Popup>
    </div>
  )
}
